import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import "./Loading.css";
import {
  Get_List_All_Sell_Contracts_Failed,
  Sell_Delete_Status,
  View_All_Sell_Contract,
} from "../../actions/Invoice_action";
import Swal from "sweetalert2";
import _ from "lodash";
import { Button, Drawer, Input, Tooltip } from "antd";
import { isMobile } from "react-device-detect";
import PropertyesList from "../../containers_Agent/Propertys_Agent/PropertyesList";
import View_AllSell from "./ViewContracts/View_AllSell";
const AllSellContract_Failed = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_All_Sell_Contracts_Failed());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const all_sell_contracts_failed = useSelector(
    (state) => state.InvoiceReducer.all_sell_contracts_failed
  );
  const S_status_failed = useSelector(
    (state) => state.InvoiceReducer.S_status_failed
  );
  const [search, setsearch] = useState("");
  const [select_property, setselect_property] = useState("");
  const [visible, setvisible] = useState(false);
  const onClose = () => {
    setvisible(false);
  };
  const showDrawer = () => {
    setvisible(true);
  };
  const onDeleteSell_Contract = (id, status) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Sell_Delete_Status(id, status));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const SellContractList_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const handleChange_Property = (value) => {
    setselect_property(value);
  };
  const datas = all_sell_contracts_failed
    .filter((data) => {
      if (isNaN(search)) {
        if (
          data.secondname &&
          data.secondname.toLowerCase().startsWith(search.toLowerCase())
        ) {
          return (
            data.secondname &&
            data.secondname.toLowerCase().startsWith(search.toLowerCase())
          );
        } else if (
          data.firstname &&
          data.firstname.toLowerCase().startsWith(search.toLowerCase())
        ) {
          return (
            data.firstname &&
            data.firstname.toLowerCase().startsWith(search.toLowerCase())
          );
        } else if (
          data.available_id &&
          data.available_id.NOoFProperty.toString().startsWith(search)
        ) {
          return (
            data.available_id &&
            data.available_id.NOoFProperty.toString().startsWith(search)
          );
        }
      } else if (select_property === "Apartment") {
        return data.available_id && data.available_id.Property === "Apartment";
      } else if (select_property === "House") {
        return data.available_id && data.available_id.Property === "House";
      } else if (select_property === "Farm") {
        return data.available_id && data.available_id.Property === "Farm";
      } else if (select_property === "Shop") {
        return data.available_id && data.available_id.Property === "Shop";
      } else if (select_property === "Vella") {
        return data.available_id && data.available_id.Property === "Vella";
      } else if (select_property === "Earth") {
        return data.available_id && data.available_id.Property === "Earth";
      } else if (select_property === "The gas station") {
        return (
          data.available_id && data.available_id.Property === "The gas station"
        );
      } else if (select_property === "Factory") {
        return data.available_id && data.available_id.Property === "Factory";
      } else if (select_property === "GYM") {
        return data.available_id && data.available_id.Property === "GYM";
      } else if (select_property === "store") {
        return data.available_id && data.available_id.Property === "store";
      } else if (select_property === "Restaurant") {
        return data.available_id && data.available_id.Property === "Restaurant";
      } else if (select_property === "Commercial Land") {
        return (
          data.available_id && data.available_id.Property === "Commercial Land"
        );
      } else if (select_property === "Company") {
        return data.available_id && data.available_id.Property === "Company";
      } else if (select_property === "Hotel") {
        return data.available_id && data.available_id.Property === "Hotel";
      } else if (select_property === "Car Garage") {
        return data.available_id && data.available_id.Property === "Car Garage";
      } else if (select_property === "Stadium") {
        return data.available_id && data.available_id.Property === "Stadium";
      } else if (select_property === "Car wash") {
        return data.available_id && data.available_id.Property === "Car wash";
      } else if (select_property === "Building") {
        return data.available_id && data.available_id.Property === "Building";
      } else if (select_property === "Agitator") {
        return data.available_id && data.available_id.Property === "Agitator";
      } else if (select_property === "Strecture") {
        return data.available_id && data.available_id.Property === "Strecture";
      } else if (select_property === "residential community") {
        return (
          data.available_id &&
          data.available_id.Property === "residential community"
        );
      } else if (select_property === "agricultural land of the register") {
        return (
          data.available_id &&
          data.available_id.Property === "agricultural land of the register"
        );
      } else if (select_property === "unregistered agricultural land") {
        return (
          data.available_id &&
          data.available_id.Property === "unregistered agricultural land"
        );
      } else if (select_property === "Government agricultural land") {
        return (
          data.available_id &&
          data.available_id.Property === "Government agricultural land"
        );
      } else if (select_property === "Land of Istamar") {
        return (
          data.available_id && data.available_id.Property === "Land of Istamar"
        );
      } else if (select_property === "Erth Musataha") {
        return (
          data.available_id && data.available_id.Property === "Erth Musataha"
        );
      } else if (select_property === "school") {
        return data.available_id && data.available_id.Property === "school";
      } else if (select_property === "Building of Istamar") {
        return (
          data.available_id &&
          data.available_id.Property === "Building of Istamar"
        );
      } else if (select_property === "Building of Musataha") {
        return (
          data.available_id &&
          data.available_id.Property === "Building of Musataha"
        );
      } else {
        if (data.lastPrice && data.lastPrice.toString().startsWith(search)) {
          return data.lastPrice && data.lastPrice.toString().startsWith(search);
        } else if (
          data.available_id &&
          data.available_id.NOoFProperty.toString().startsWith(search)
        ) {
          return (
            data.available_id &&
            data.available_id.NOoFProperty.toString().startsWith(search)
          );
        } else {
          return data.InvoiceNO && data.InvoiceNO.toString().startsWith(search);
        }
      }
    })
    .map((el, i) => {
      return {
        id: el.InvoiceNO,
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => {
                  dispatch(View_All_Sell_Contract(el._id, el.InvoiceNO));
                  showDrawer();
                }}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => onDeleteSell_Contract(el._id, "delete")}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
        branchId: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId && el.branchId.name}
          </span>
        ),
        property_detail: (
          <>
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id &&
                dispatch(change_Lang(el.available_id.Property))}
            </span>
            &nbsp;-&nbsp;
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id && el.available_id.NOoFProperty}
            </span>
          </>
        ),
        Agent_name: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{`${
            el.agentId && el.agentId.fname
          } ${el.agentId && el.agentId.lname}`}</span>
        ),
        Area: <span className={`${lang === "en" ? "" : "fk"}`}>{el.Area}</span>,
        phone: el.Phone,
        firstName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.firstname}</span>
        ),
        secondName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.secondname}
          </span>
        ),
        lastPrice: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.lastPrice}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix="$"
          />
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
      width: "80px",
    },
    {
      name: dispatch(change_Lang("Name of Branch")),
      selector: "branchId",
      center: true,
      compact: true,
      width: "110px",
    },
    {
      name: dispatch(change_Lang("Property Detail")),
      selector: "property_detail",
      center: true,
      compact: true,
      width: "150px",
    },
    {
      name: dispatch(change_Lang("First Party (Seller)")),
      selector: "firstName",
      center: true,
      compact: true,
      width: "180px",
    },
    {
      name: dispatch(change_Lang("Second Party (Buyer)")),
      selector: "secondName",
      center: true,
      compact: true,
      width: "260px",
    },
    {
      name: dispatch(change_Lang("pr_price")),
      selector: "lastPrice",
      center: true,
      compact: true,
      width: "120px",
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
      width: "120px",
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const Total_Property_Price = _.sumBy(all_sell_contracts_failed, function (o) {
    if (o.status !== "delete" && select_property) {
      if (o.available_id && o.available_id.Property === select_property) {
        return o.lastPrice;
      } else {
        return 0;
      }
    } else {
      return o.lastPrice;
    }
  });
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Fast-selling contracts"))}
          parent={dispatch(change_Lang("Contract List"))}
        />
        {S_status_failed !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div>
                    <div className="row">
                      <div
                        className={
                          isMobile
                            ? "col-md-3 d-flex justify-content-center"
                            : "col-md-3 d-flex justify-content-start"
                        }
                      >
                        <PropertyesList
                          onChangeProperty={handleChange_Property}
                          valueOption={select_property}
                          className="fk text-center"
                          size="middle"
                          showSearch
                          optionFilterProp="children"
                          filterOption={true}
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#052f43",
                            width: "200px",
                          }}
                          showArrow={false}
                        />
                        {/* &nbsp;{" "}
                        <Link
                          onClick={SellContractList_getPrint}
                          to={`/Print_all_contractSell/${
                            select_property ? select_property : "all"
                          }`}
                        >
                          <Button
                            title={dispatch(change_Lang("Print"))}
                            style={{
                              background: "#efefed",
                              color: "#4064d7",
                              border: "none",
                            }}
                            icon={
                              <i className="fa fa-print" aria-hidden="true"></i>
                            }
                          />
                        </Link> */}
                      </div>
                      <div className={"col-md-6"}>
                        <div className=" text-center mt-2">
                          <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                            {dispatch(change_Lang("Fast-selling contracts"))}
                          </h3>
                        </div>
                      </div>
                      <div className="col-md-3 m-auto">
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        data={datas}
                        pagination={true}
                        noDataComponent={dispatch(change_Lang("table_display"))}
                        striped
                      />
                    </div>
                    <br />
                    <div class="container">
                      <ul class="responsive-table">
                        <li class="table-header">
                          <div class="col d-flex justify-content-center">
                            <span style={{ fontSize: "16px" }}>
                              {" "}
                              کۆی گشتی پارەی (
                              {`${
                                select_property !== ""
                                  ? dispatch(change_Lang(select_property))
                                  : dispatch(change_Lang("All properties"))
                              }`}
                              )
                            </span>
                          </div>
                        </li>
                        <td></td>
                        <li class="table-row">
                          <div
                            class="col d-flex justify-content-center"
                            data-label="Payment Status"
                          >
                            <NumberFormat
                              displayType="text"
                              thousandSeparator={true}
                              value={Total_Property_Price}
                              className={`${lang === "en" ? "" : "fk"}`}
                              prefix="$"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Drawer onClose={onClose} open={visible} width="950px">
              <View_AllSell onClose={onClose} />
            </Drawer>
          </>
        )}
      </Fragment>
    </>
  );
};

export default AllSellContract_Failed;
